<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Dotação Orçamentária"
                @click.stop="confirmarExcluirDotacao()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        rateio: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluirDotacao() {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Confirma a exclusão da dotação orçamentária<br/><b>${this.rateio.unidade}<br/>${this.rateio.projeto}<br/>${this.rateio.acao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluirDotacao()
                }
            })
        },

        excluirDotacao() {
            this.$emit('excluirRateio')
        }

        // registroSalvoComSucesso(data) {
        //     this.$toast.success(
        //         'Registro salvo com sucesso!',
        //         'OK',
        //         this.$toastConfig.success
        //     )
        //     this.$emit('obterDotacoesAtualizadas')
        // }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
